import React, { useContext, useEffect, useState } from 'react'
import { Card, } from 'components/common'
import { renderToString } from 'react-dom/server'
import styled from 'styled-components'
import TimezoneSelect from 'app-components/common/TImezoneSelect'
import { useTranslation } from 'react-i18next'
import UpdatableChart from 'app-components/common/UpdatableChart'

// import RejectionsModal from 'app-components/run-in-hole/job-summary/RejectionsModal'
import { JobContext } from 'stores/JobStore'
import CustomDateTooltip from 'app-components/common/CustomDateToolTip'


const ResponsiveChart = styled(UpdatableChart)`
    max-width: 1500px;
    width: 100%;
    margin: 0px auto;
    flex-wrap: wrap;
`

const Subtitle = styled.h3`
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;
    text-align: justify;
    color: #777777;
    margin: 16px 0;
`

// const language = localStorage.getItem('language').toString()

const translates = [{
  name: 'en',
  options: {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    toolbar: {
      download: 'Download SVG',
      selection: 'Selection',
      selectionZoom: 'Selection Zoom',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
      pan: 'Panning',
      reset: 'Reset Zoom',
    }
  }
},
{
  name: 'pt',
  options: {
    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    toolbar: {
      download: 'Baixar SVG',
      selection: 'Seleção',
      selectionZoom: 'Seleção de Zoom',
      zoomIn: 'Aumentar o Zoom',
      zoomOut: 'Reduzir o Zoom',
      pan: 'Panorâmica',
      reset: 'Redefinir Zoom',
    }
  }
}]

const chartFormattingDefault = {
  series: [
    {
      name: 'Depth',
      type: 'line',
      data: []
    },
    {
      name: 'Stoppages',
      type: 'scatter',
      data: []
    },
    {
      name: 'Stoppings',
      type: 'bar',
      data: [],
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      },
    }],
  options: {
    chart: {
      id: 'downhole_chart',
      defaultLocale: 'en',
      locales: translates,
      fontFamily: 'Noto Sans',
      toolbar: {
        tools: {
          download: false
        }
      }
    },
    fill: {
      type: 'solid',
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      curve: 'straight',
      lineCap: 'round',
      colors: '#59CBE4',
      width: 2,
      dashArray: 0,
    },
    grid: {
      padding: {
        right: 10,
        left: 30
      }
    },
    yaxis: {
      labels: {
        show: true,
        align: 'right',
        minWidth: 0,
        maxWidth: 160,
        // formatter: (value) =>  (value + ' m'),
        style: {
          colors: [],
          fontSize: '12px',
          fontFamily: 'Noto Sans',
          fontWeight: 600,
          cssClass: 'apexcharts-yaxis-label',
        },
        offsetX: 10,
        offsetY: 0,
        rotate: 0
      }
    },
    xaxis: {
      type: 'datetime',
      categories: [],
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: false,
        hideOverlappingLabels: true,
        showDuplicates: true,
        trim: false,
        minHeight: undefined,
        maxHeight: 120,
        style: {
          colors: [],
          fontSize: '12px',
          fontFamily: 'Noto Sans',
          fontWeight: 600,
          cssClass: 'apexcharts-xaxis-label',
        },
        offsetX: 0,
        offsetY: 0,
        format: undefined,
        formatter: undefined,
        datetimeUTC: false,
        datetimeFormatter: {
          year: 'yyyy',
          month: "MMM 'yy",
          day: 'dd MMM',
          hour: 'HH:mm',
        }
      }
    },
    markers: {
      size: 5,
      colors: '#59CBE4',
      strokeColors: '#59CBE4',
      strokeWidth: 0,
      strokeOpacity: 0.9,
      strokeDashArray: -10,
      fillOpacity: 0.5,
      discrete: [],
      shape: "circle",
      radius: 0.5,
      offsetX: 0,
      offsetY: 0,
      onClick: undefined,
      onDblClick: undefined,
      showNullDataPoints: true,
      hover: {
        size: 15,
        sizeOffset: 3
      }
    },
    axisBorder: {
      show: true,
      color: '#78909C',
      height: 1,
      width: '100%',
      offsetX: 0,
      offsetY: 0
    },
    axisTicks: {
      show: true,
      borderType: 'solid',
      color: '#78909C',
      height: 6,
      offsetX: 0,
      offsetY: 0
    },
    tickAmount: 20,
    tickPlacement: 'between',
    min: undefined,
    max: undefined,
    range: undefined,
    floating: false,
    position: 'bottom',
    legend: {
      show: false
    }
  }
}

const DescentChart = () => {
  const {
    chartData,
    chartStoppagesData,
    // pipesSummary,
    // accessoriesSummary,
    isJobDetailsLoading,
    chartTimezone,
    updateChartTimezone
  } = useContext(JobContext)

  const [chartFormatting, setChartFormatting] = useState(chartFormattingDefault)
  const { t } = useTranslation()
  // const [chooseModelModalVisible, setChooseModelModalVisible] = useState(false)
  // const openRejectionsModal = () => {
  //     setChooseModelModalVisible(true)
  // }
  // const closeRejectionsModal = () => {
  //     setChooseModelModalVisible(false)
  // }



  const chartXaxis = chartStoppagesData.map((itemChart => {
    return {
      x: new Date(itemChart.start_time).getTime(),
      x2: new Date(itemChart.end_time).getTime(),
      borderColor: "#000",
      style: {
        color: "#000",
        background: "#fff"
      }
    }
  }))

  useEffect(() => {
    setChartFormatting(chartFormatting => ({
      series: [
        {
          name: 'Depth',
          type: 'line',
          data: chartData
        },
        {
          name: 'Stoppages',
          type: 'scatter',
          data: chartStoppagesData
        },
        {
          name: 'Stoppings',
          type: 'bar',
          data: chartStoppagesData,
        },
      ],
      options: {
        ...chartFormatting.options,
        xaxis: {
          ...chartFormatting.options.xaxis,
          categories: chartData,
        },
        tooltip: {
          custom: ({ seriesIndex, dataPointIndex }) => {
            return seriesIndex === 0
              ? renderToString(<CustomDateTooltip chartObject={chartData[dataPointIndex]} timezone={chartTimezone} />)
              : renderToString(<CustomDateTooltip chartObject={chartStoppagesData[dataPointIndex]} timezone={chartTimezone} />)
          }
        },
        annotations: {
          xaxis: chartXaxis
        }
      }
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData, chartStoppagesData, chartTimezone])

  return (
    <Card>
      <Subtitle>{t('Chart')}</Subtitle>
      <TimezoneSelect setTimezone={(timezone) => updateChartTimezone(timezone)} value={chartTimezone}></TimezoneSelect>

      {
        (chartFormatting && chartFormatting.options && chartFormatting.series && !isJobDetailsLoading)
          ? <ResponsiveChart options={chartFormatting.options} series={chartFormatting.series} type="line" height="600px" />
          : null
      }

    </Card>
  )

}

export default DescentChart